import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class ArchivedCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
    }
}
